import gql from 'graphql-tag';

export const LISTING_FEATURES_FRAGMENT = gql`
    fragment LISTING_FEATURES_FRAGMENT on ListingData {
        detailedDescription
        features {
            bullets
            flags {
                furnishedState {
                    name
                    label
                }
                studentFriendly
                tenure {
                    name
                    label
                }
            }
            highlights {
                description
                label
            }
        }
    }
`;
